import React from 'react';
import {
  Box,
  Flex,
  Image,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text
} from '@chakra-ui/react';
import CloseModalIcon from '../../../../../assets/close-modal-icon.svg';
import Button from '../../../../../components/Button';

function VerificationPendingModal(props) {
  const { isOpen, onClick, Icon, title, desc, titleBtn, onClose, textAlign = 'center' } = props;
  return (
    <>
      <Modal isOpen={isOpen} isCentered onClose={onClose}>
        <ModalOverlay />
        <ModalContent rounded={'12px'} w={'423px'} p={'20px 15px'} bgColor={'light.200'}>
          <ModalHeader p={0} w={'100%'} m={0} maxWidth={'unset'}>
            <div className="flex w-full items-center justify-between pb-2 border-b border-earth-brown-50">
              <p className="text-xl font-[800]">{title}</p>
              <Image
                className="w-[40px] h-[40px] cursor-pointer"
                src={CloseModalIcon}
                onClick={onClose}
                alt=""
              />
            </div>
          </ModalHeader>
          <ModalBody p={0} my={'24px'}>
            <Box w={'53px'} h={'53px'} margin="auto" my={'16px'}>
              <img src={Icon} alt="" className="w-[53px] h-[53px] block"></img>
            </Box>
            <Flex flexDirection={'column'} gap={'10px'} fontWeight={600}>
              <Text fontSize={'1.125rem'} textAlign={textAlign}>
                {desc}
              </Text>
            </Flex>
          </ModalBody>
          <ModalFooter p="0" gap={'10px'} textAlign={'center'}>
            <Button onClick={onClick} className="w-full h-[42px] !text-base">
              {titleBtn}
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
}

export default VerificationPendingModal;
